import ArcGisLayer from '@arcgis/core/layers/Layer';
import KMLLayer from '@arcgis/core/layers/KMLLayer';
import { Layer } from '../../../../models/layer-settings';
import { convertDataLayer } from './layer-conversions';
import { convertWMSLayerToArcGISLayer } from '../../utils/wms-utils';

const convertableLayerTypes = ['mbtiles', 'fulcrum', 'xyz', 'data'];

export type LayerConverter =
  (layer: Layer) => ArcGisLayer | Promise<any>;

const StandardLayerConverter: LayerConverter = (layer: Layer) => {
  if (convertableLayerTypes.includes(layer.type)) {
    return convertDataLayer(layer);
  }

  if (layer.type === 'wms') {
    return convertWMSLayerToArcGISLayer(layer);
  }

  if (layer.type === 'kml') {
    return new KMLLayer({ url: layer.url });
  }

  return null;
};

export default StandardLayerConverter;
